import { useEffect, useRef, useState } from "react";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

interface Props {
  content: string;
  buttonValue: string;
  copiedValue?: string;
  buttonSize?: "sm" | "lg";
  className?: string;
}

export function CopyToClipboardButton(props: Props) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef<number | undefined>(undefined);

  useEffect(() => {
    return () => {
      if (timeoutRef.current !== undefined) {
        window.clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <Button
      color={copied ? "success" : "primary"}
      size={props.buttonSize}
      className={props.className}
      onClick={() => {
        void navigator.clipboard.writeText(props.content);
        setCopied(true);
        if (timeoutRef.current !== undefined) {
          window.clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = window.setTimeout(() => {
          setCopied(false);
        }, 3000);
      }}
    >
      <FontAwesomeIcon icon={faCopy} />{" "}
      {copied
        ? (props.copiedValue ?? t("common.copiedToClipboard"))
        : props.buttonValue}
    </Button>
  );
}
